import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

import { handleTransformErrorResponse } from '@/utils/handleTransformErrorResponse'

import { api } from '..'

import {
  AksInfoRequestDto,
  AksInfoResponseDto,
  DriverStatusRequestDto,
  DriverStatusResponseDto,
  LastUpdateRequestDto,
  LastUpdateResponseDto,
  OperationsRequestDto,
  OperationsResponseDto,
  VehicleWorkOrderRequestDto,
  VehicleWorkOrderResponseDto,
} from './OperationService.dto'

export const operationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLastUpdate: builder.query<LastUpdateResponseDto, LastUpdateRequestDto>({
      query: ({ phoneNumber }) => ({
        url: `/operation/GetLastUpdate/${phoneNumber}`,
        method: 'GET',
        params: { phoneNumber },
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => handleTransformErrorResponse(error),
      providesTags: ['DriverStatus', 'Status', 'Auth'],
    }),
    sendChangeDriverStatus: builder.mutation<DriverStatusResponseDto, DriverStatusRequestDto>({
      query: (params) => ({
        url: '/operation/ChangeDriverStatus',
        method: 'POST',
        body: params,
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => handleTransformErrorResponse(error),
      invalidatesTags: ['DriverStatus'],
    }),
    getVehicleWorkOrder: builder.query<VehicleWorkOrderResponseDto[], VehicleWorkOrderRequestDto>({
      query: ({ plate }) => ({
        url: `operation/SetVehicleWorkOrder/${plate}`,
        method: 'GET',
        params: { plate },
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => handleTransformErrorResponse(error),
      providesTags: ['WorkStatus'],
    }),
    sendOperations: builder.mutation<OperationsResponseDto, OperationsRequestDto>({
      query: (params) => ({
        url: '/operation/Operations',
        method: 'POST',
        body: params,
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => handleTransformErrorResponse(error),
      invalidatesTags: ['WorkStatus', 'Status'],
    }),
    getAksInfo: builder.query<AksInfoResponseDto, AksInfoRequestDto>({
      query: (params) => ({
        url: '/operation/GetAksInfo/aks-info',
        method: 'POST',
        body: params,
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => handleTransformErrorResponse(error),
    }),
  }),
})

export const {
  useGetLastUpdateQuery,
  useGetVehicleWorkOrderQuery,
  useSendChangeDriverStatusMutation,
  useSendOperationsMutation,
  useLazyGetAksInfoQuery,
} = operationApi
